import { Box, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { theme } from '../../theme';

interface PageTitleProps {
  children: React.ReactNode;
  subTitle?: string;
}


const PageTitle: React.FC<PageTitleProps> = props => {
  return (
    <Box sx={{ mb: 3 }}>
      <Stack>
        <Typography
          variant="displaySM"
          sx={{ fontWeight: 600 }}>
          {props.children}
        </Typography>
        <Typography color={theme.palette.custom.gray[600]}
          variant="textMD"
          sx={{ fontWeight: 400 }}>
          {props.subTitle}
        </Typography>
      </Stack>
    </Box>
  );
};

export default PageTitle;